import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from '../NoData';
import ChartLoader from '../ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain/WaterMark";


function AvgDDBar({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "20": { per: 0, count: 0 },
      "40": { per: 0, count: 0 },
      "60": { per: 0, count: 0 },
      "80": { per: 0, count: 0 },
      "100": { per: 0, count: 0 }
    };
    if (res_result.length != 0) {
      let t_val = res_result[0];
      if (t_val.doc_count != 0) {
        if (t_val.disc0_20.sum > 0) {
          responce["20"] = { per: parseInt(t_val.disc0_20.avg * 100), sum: parseInt(t_val.disc0_20.sum) };
        }
        if (t_val.disc21_40.sum > 0) {
          responce["40"] = { per: parseInt(t_val.disc21_40.avg * 100), sum: parseInt(t_val.disc21_40.sum) };
        }
        if (t_val.disc41_60.sum > 0) {
          responce["60"] = { per: parseInt(t_val.disc41_60.avg * 100), sum: parseInt(t_val.disc41_60.sum) };
        }
        if (t_val.disc61_80.sum > 0) {
          responce["80"] = { per: parseInt(t_val.disc61_80.avg * 100), sum: parseInt(t_val.disc61_80.sum) };
        }
        if (t_val.disc81_100.sum > 0) {
          responce["100"] = { per: parseInt(t_val.disc81_100.avg * 100), sum: parseInt(t_val.disc81_100.sum) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]
        let loop_keys = Object.keys(responce);
        loop_keys.map(x => {
          if (x != "e478ba8c" && x != "doc_count") {
            // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].sum + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "#348393"]);
            res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].sum + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;color:#348393"]);
          }
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Soc Discharge',
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Discharge Cycles',
      minValue: 0,
      format: '#\'%\'',
    },
    // bar: { groupWidth: "90%" },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="chartHGT">
        <WaterMark />
        {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="180px" data={chartdata} options={options} />)}
      </div>
    </>
  );
}

export default AvgDDBar;